import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { useUiStore } from '@/store/uiStore';

/**
 * Invisible helper rendered as a child of <MapContainer>. It watches for
 * "fly to" requests placed on the UI store (e.g. from the county/city jump
 * dropdowns in MapControls, which live outside the Leaflet context and can't
 * call useMap() directly) and pans/zooms the live map instance to match.
 */
export function MapFlyToController() {
  const map = useMap();
  const flyToTarget = useUiStore((s) => s.flyToTarget);
  const clearFlyToTarget = useUiStore((s) => s.clearFlyToTarget);

  useEffect(() => {
    if (!flyToTarget) return;
    map.flyTo([flyToTarget.lat, flyToTarget.lon], flyToTarget.zoom ?? map.getZoom());
    clearFlyToTarget();
  }, [flyToTarget, map, clearFlyToTarget]);

  return null;
}
